export const Upload = ({ ...props }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
      fill="#E0F2FD"
    />
    <path
      d="M19.9989 11.6693L20.3499 11.3132C20.1552 11.1213 19.8425 11.1213 19.6479 11.3132L19.9989 11.6693ZM12.916 28.3359L12.416 28.3359L12.416 28.8359L12.916 28.8359L12.916 28.3359ZM27.0827 28.3359V28.8359L27.5827 28.8359V28.3359L27.0827 28.3359ZM19.9989 24.0455L20.4989 24.0455V11.6693L19.9989 11.6693L19.4989 11.6693V24.0455L19.9989 24.0455ZM19.9989 11.6693L19.6479 11.3132L15.432 15.4699L15.7831 15.826L16.1341 16.182L20.3499 12.0253L19.9989 11.6693ZM24.2156 15.826L24.5666 15.4699L20.3499 11.3132L19.9989 11.6693L19.6479 12.0253L23.8646 16.182L24.2156 15.826ZM12.916 25.3656L12.416 25.3656L12.416 28.3359L12.916 28.3359L13.416 28.3359L13.416 25.3656L12.916 25.3656ZM12.916 28.3359L12.916 28.8359L27.0827 28.8359V28.3359V27.8359L12.916 27.8359L12.916 28.3359ZM27.0827 28.3359L27.5827 28.3359V25.3656L27.0827 25.3656L26.5827 25.3656V28.3359L27.0827 28.3359Z"
      fill="#222222"
    />
  </svg>
)
